var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w1200 aboutUs"},[_c('h1',{staticClass:"title"},[_vm._v("关于我们")]),_c('div',{staticClass:"hasbg",domProps:{"innerHTML":_vm._s(_vm.content)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }